import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnSuccess,
    HasOnError,
} from "@insite/client-framework/HandlerCreator";
import { deleteDivision } from "@tCentro/Services/CENAdminDivisionService";

export interface DeleteDivisionParameter extends HasOnSuccess<void>, HasOnError<string> {
    divisionId: string;
}

type HandlerType = ApiHandler<DeleteDivisionParameter, {}>;

export const DeleteDivision: HandlerType = async props => {
    try {
        await deleteDivision(props.parameter.divisionId);
        if (props.parameter.onSuccess) {
            props.parameter.onSuccess();
        }
    } catch (error: any) {
        if (props.parameter.onError) {
            props.parameter.onError(error?.message ?? "Failed to delete division");
        }
    }
};

export const chain = [DeleteDivision];
const deleteDivisionData = createHandlerChainRunner(chain, "deleteDivisionData");
export default deleteDivisionData;
